var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAnalytics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1666 6.25V14.5833C29.1666 15.1359 29.3861 15.6658 29.7768 16.0565C30.1675 16.4472 30.6974 16.6667 31.25 16.6667H39.5833M29.1666 6.25H14.5833C13.4782 6.25 12.4184 6.68899 11.637 7.47039C10.8556 8.25179 10.4166 9.3116 10.4166 10.4167V39.5833C10.4166 40.6884 10.8556 41.7482 11.637 42.5296C12.4184 43.311 13.4782 43.75 14.5833 43.75H35.4166C36.5217 43.75 37.5815 43.311 38.3629 42.5296C39.1443 41.7482 39.5833 40.6884 39.5833 39.5833V16.6667M29.1666 6.25L39.5833 16.6667M18.75 35.4167V25M25 35.4167V33.3333M31.25 35.4167V29.1667",
    stroke: "#FF9500",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAnalytics);
export default __webpack_public_path__ + "static/media/file-analytics.6c269060a437d2b732c365d5b62a65c7.svg";
export { ForwardRef as ReactComponent };